import { polyLine2EdgeCount, polyLine2IsAxisAlignedEdge } from "geom/polyLine2";
import type { DocMigration } from "../docMigration";

// Copied from lib/house/plans/interiorDimensionsByRoomGroup.ts
const ALIGNED_WALL_EPSILON = 0.0001;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_126: DocMigration = {
  maxSchemaVersion: "0.0.126",
  description: "Increased tolerance for axis aligned wall dimensions.",
  apply(json: any) {
    if (json.roomLayouts && json.rooms) {
      for (const roomId in json.roomLayouts) {
        const roomLayout = json.roomLayouts[roomId];
        const room = json.rooms[roomId];

        if (room && roomLayout) {
          const { outline, edgeIds } = room;
          const { edgeDimensionBehavior = [] } = roomLayout;

          for (let i = 0, l = polyLine2EdgeCount(outline); i < l; i++) {
            const edgeId = edgeIds[i];
            let dimensionBehavior;
            for (const behavior of edgeDimensionBehavior) {
              if (behavior.edgeId === edgeId) {
                dimensionBehavior = behavior;
                break;
              }
            }

            const wasAligned = polyLine2IsAxisAlignedEdge(outline, i);
            const isAligned = polyLine2IsAxisAlignedEdge(outline, i, ALIGNED_WALL_EPSILON);

            //console.log(i, wasAligned, isAligned);

            if (!wasAligned && isAligned) {
              if (dimensionBehavior) {
                dimensionBehavior.disableAuto = true;
              } else {
                edgeDimensionBehavior.push({
                  edgeId,
                  disableAuto: true,
                });
              }
            }
          }

          if (edgeDimensionBehavior.length > 0) {
            roomLayout.edgeDimensionBehavior = edgeDimensionBehavior;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_126;
